import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo-2.svg'
import './ContactPage.scss';

const ContactPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} isSecondary={true} />

            {/* Hero Section */}
            <section className="contact-hero-section">
                <div className="hero-overlay"></div>
                <div className="container">
                    <div className="hero-content">
                        <h1>Schedule Your Consultation</h1>
                        <p className="hero-subtitle">
                            Start your journey to better health with a personalized consultation.
                        </p>
                    </div>
                </div>
            </section>

            <Contactpage />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;

